(function(){
  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function refreshCart(){
    document.dispatchEvent(new CustomEvent('theme:cart:refresh',{bubbles:true}));
    document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  }
  function addToCart(button){
    var variantId = button.getAttribute('data-bnv2-variant-id');
    if(!variantId || button.disabled) return;
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'DODAJĘ';
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:Number(variantId),quantity:1})
    })
    .then(function(response){
      if(!response.ok) return response.json().then(function(error){throw error;});
      return response.json();
    })
    .then(function(){
      button.classList.add('is-added');
      button.textContent = 'DODANO';
      refreshCart();
      setTimeout(function(){
        button.classList.remove('is-added');
        button.disabled = false;
        button.textContent = original;
      },1400);
    })
    .catch(function(){
      button.disabled = false;
      button.textContent = 'NIEDOSTĘPNE';
      setTimeout(function(){button.textContent = original;},1800);
    });
  }

  function initHoverVideos(root){
    root.querySelectorAll('video.bnv2-product__secondary:not([data-bnv2-hover-ready])').forEach(function(video){
      video.setAttribute('data-bnv2-hover-ready','true');
      var card = video.closest('.bnv2-product');
      if(!card) return;
      function play(){ video.play().catch(function(){}); }
      function stop(){ video.pause(); try{video.currentTime=0;}catch(e){} }
      card.addEventListener('mouseenter',play);
      card.addEventListener('mouseleave',stop);
      card.addEventListener('focusin',play);
      card.addEventListener('focusout',stop);
    });
  }

  function initCarousels(root){
    root.querySelectorAll('[data-bnv2-carousel-shell]:not([data-bnv2-carousel-ready])').forEach(function(shell){
      shell.setAttribute('data-bnv2-carousel-ready','true');
      var rail=shell.querySelector('[data-bnv2-carousel]');
      var prev=shell.querySelector('[data-bnv2-prev]');
      var next=shell.querySelector('[data-bnv2-next]');
      var fill=shell.querySelector('[data-bnv2-progress]');
      if(!rail) return;

      function step(){
        var card=rail.querySelector('.bnv2-family');
        return card ? card.getBoundingClientRect().width + 12 : rail.clientWidth*.8;
      }
      function update(){
        var max=Math.max(1,rail.scrollWidth-rail.clientWidth);
        var pct=Math.max(0,Math.min(100,(rail.scrollLeft/max)*100));
        if(fill) fill.style.width=(rail.scrollWidth<=rail.clientWidth ? 100 : pct)+'%';
        if(prev) prev.disabled=rail.scrollLeft<3;
        if(next) next.disabled=rail.scrollLeft>=max-3;
      }
      if(prev) prev.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:'smooth'});});
      if(next) next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:'smooth'});});
      rail.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update);
      update();
    });
  }

  function init(root){
    root = root || document;
    document.body.classList.add('bn-home-v2');
    root.querySelectorAll('[data-bnv2-atc]:not([data-bnv2-ready])').forEach(function(button){
      button.setAttribute('data-bnv2-ready','true');
      button.addEventListener('click',function(){addToCart(button);});
    });

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!reduce && 'IntersectionObserver' in window){
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          var video = entry.target;
          if(entry.isIntersecting) video.play().catch(function(){});
          else video.pause();
        });
      },{threshold:.28});
      root.querySelectorAll('video[data-bnv2-autoplay]:not([data-bnv2-observed])').forEach(function(video){
        video.setAttribute('data-bnv2-observed','true');
        observer.observe(video);
      });
    }

    initHoverVideos(root);
    initCarousels(root);

    root.querySelectorAll('[data-bnv2-poll]:not([data-bnv2-ready])').forEach(function(poll){
      poll.setAttribute('data-bnv2-ready','true');
      poll.querySelectorAll('button').forEach(function(button){
        button.addEventListener('click',function(){
          poll.querySelectorAll('button').forEach(function(item){item.setAttribute('aria-pressed','false');});
          button.setAttribute('aria-pressed','true');
        });
      });
    });
  }
  ready(function(){init(document);});
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();